module.exports = "/_next/static/media/55459c914908dd43ca1ac29d6cafd10b.svg";